export const ButtonSizes = {
  SMALL: 'SMALL',
  LARGE: 'LARGE',
  XLARGE: 'XLARGE'
};

export const ButtonShapes = {
  FILLED: 'FILLED',
  OUTLINED: 'OUTLINED',
  LINKED: 'LINKED',
  NAKED: 'NAKED',
  NAKED_LIGHT: 'NAKED_LIGHT'
};
